<p-dialog [(visible)]="isVisible" styleClass="quick-view-grid-row y-hidden " icon="pi pi-exclamation-triangle"
width="425" width="425" appendTo="body" showEffect="fade" [modal]="true" (onHide)="onHide()" header="Counterparty Report"
styleClass="counterparty-report-dialog">
  <div class="col-lg-12 ">
    <div class="col-lg-4"><label for="reportDate">Report Date</label></div>
    <div class="col-lg-8">        
        <app-datepicker-calendar [dateRange]="counterPartyReport.reportDate" [isDateRange]="true"  (dateChange)="getDateEmitter()"></app-datepicker-calendar>
      </div>
  </div>
  <div class="col-lg-12  mg-t-5">
    <div class="col-lg-4"><label for="Destination">Destination</label></div>
    <div class="col-lg-8">
        <p-multiSelect id="filterDrpbyTypeMultiSelect" 
        autofocus 
        [options]="destinationList" [(ngModel)]="counterPartyReport.destination" appendTo="body"
        placeholder="Choose"
        [style]="{ 'text-transform': 'capitalize','overflow':'visible','width':'100%'}"
        class="counterparty-multiselect-dropdown">
        <ng-template let-filterCols pTemplate="item" >
            <span [id]="filterCols.label" class="ui-helper-clearfix counterparty-multiselect-dropdown" [matTooltip]="filterCols?.description"
            [matTooltipShowDelay]="1000"  matTooltipPosition="after">
                {{filterCols?.label}}</span>
        </ng-template>
    </p-multiSelect>
    </div>
  </div>
  <div class="col-lg-12 mg-t-5">
      <div class="col-lg-4"><label for="SenderIMID">SenderIMID</label></div>
      <div class="col-lg-8">
          <p-multiSelect id="filterDrpbyTypeMultiSelect" 
          autofocus 
          [options]="senderIMID" [(ngModel)]="counterPartyReport.senderIMID" appendTo="body"
          placeholder="Choose"
          [style]="{ 'text-transform': 'capitalize','overflow':'visible','width':'100%'}"
          class="counterparty-multiselect-dropdown">
          <ng-template let-filterCols pTemplate="item" >
              <span [id]="filterCols.label" class="ui-helper-clearfix" [matTooltip]="filterCols?.description"
              [matTooltipShowDelay]="1000"  matTooltipPosition="after">
                  {{filterCols?.label}}</span>
          </ng-template>
      </p-multiSelect>
      </div>
    </div>
  <div class="col-lg-12 ">
    <div class="col-lg-4"><label for="Symbol">Symbol</label></div>
    <div class="col-lg-8">
      <input  class="mg-t-5" style="width:100%" name="Symbol" id="Symbol_inp" [(ngModel)]="counterPartyReport.symbol">
    </div>
  </div>
  
  <div class="col-lg-12 ">
      <div class="col-lg-4"></div>
      <div class="col-lg-8">
          <mat-checkbox color="primary" id="Individual_file" [(ngModel)]="isIndividualFile" >Individual file</mat-checkbox>
          <button type="button" class="btn-DodgerBlue generate-report-button float-right" 
          id="Generate" (click)="generateFile()">Generate
        </button> 
      </div>
     
  </div>
  
</p-dialog>